// @generated by protoc-gen-es v1.10.0 with parameter "target=ts"
// @generated from file gdx/gateway/web/payment/v2/payment.proto (package gdx.gateway.web.payment.v2, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import type { BinaryReadOptions, FieldList, JsonReadOptions, JsonValue, PartialMessage, PlainMessage } from "@bufbuild/protobuf";
import { Message, proto3, protoInt64, Timestamp } from "@bufbuild/protobuf";

/**
 * Available charge types.
 *
 * @generated from enum gdx.gateway.web.payment.v2.ChargeType
 */
export enum ChargeType {
  /**
   * @generated from enum value: CHARGE_TYPE_INVALID = 0;
   */
  INVALID = 0,

  /**
   * @generated from enum value: CHARGE_TYPE_MANUAL = 1;
   */
  MANUAL = 1,

  /**
   * @generated from enum value: CHARGE_TYPE_AUTO = 2;
   */
  AUTO = 2,
}
// Retrieve enum metadata with: proto3.getEnumType(ChargeType)
proto3.util.setEnumType(ChargeType, "gdx.gateway.web.payment.v2.ChargeType", [
  { no: 0, name: "CHARGE_TYPE_INVALID" },
  { no: 1, name: "CHARGE_TYPE_MANUAL" },
  { no: 2, name: "CHARGE_TYPE_AUTO" },
]);

/**
 * Describes order status.
 *
 * @generated from enum gdx.gateway.web.payment.v2.OrderStatus
 */
export enum OrderStatus {
  /**
   * @generated from enum value: ORDER_STATUS_INVALID = 0;
   */
  ORDER_STATUS_INVALID = 0,

  /**
   * @generated from enum value: ORDER_STATUS_CREATED = 1;
   */
  ORDER_STATUS_CREATED = 1,

  /**
   * @generated from enum value: ORDER_STATUS_PROCESSING = 2;
   */
  ORDER_STATUS_PROCESSING = 2,

  /**
   * @generated from enum value: ORDER_STATUS_APPROVED = 3;
   */
  ORDER_STATUS_APPROVED = 3,

  /**
   * @generated from enum value: ORDER_STATUS_DECLINED = 4;
   */
  ORDER_STATUS_DECLINED = 4,

  /**
   * @generated from enum value: ORDER_STATUS_REFUNDED = 5;
   */
  ORDER_STATUS_REFUNDED = 5,

  /**
   * @generated from enum value: ORDER_STATUS_AUTHORIZED = 6;
   */
  ORDER_STATUS_AUTHORIZED = 6,

  /**
   * @generated from enum value: ORDER_STATUS_3DS_VERIFY = 7;
   */
  ORDER_STATUS_3DS_VERIFY = 7,

  /**
   * @generated from enum value: ORDER_STATUS_AUTH_FAILED = 8;
   */
  ORDER_STATUS_AUTH_FAILED = 8,

  /**
   * @generated from enum value: ORDER_STATUS_VOID_OK = 9;
   */
  ORDER_STATUS_VOID_OK = 9,

  /**
   * @generated from enum value: ORDER_STATUS_SETTLE_OK = 10;
   */
  ORDER_STATUS_SETTLE_OK = 10,

  /**
   * @generated from enum value: ORDER_STATUS_PARTIAL_SETTLED = 11;
   */
  ORDER_STATUS_PARTIAL_SETTLED = 11,
}
// Retrieve enum metadata with: proto3.getEnumType(OrderStatus)
proto3.util.setEnumType(OrderStatus, "gdx.gateway.web.payment.v2.OrderStatus", [
  { no: 0, name: "ORDER_STATUS_INVALID" },
  { no: 1, name: "ORDER_STATUS_CREATED" },
  { no: 2, name: "ORDER_STATUS_PROCESSING" },
  { no: 3, name: "ORDER_STATUS_APPROVED" },
  { no: 4, name: "ORDER_STATUS_DECLINED" },
  { no: 5, name: "ORDER_STATUS_REFUNDED" },
  { no: 6, name: "ORDER_STATUS_AUTHORIZED" },
  { no: 7, name: "ORDER_STATUS_3DS_VERIFY" },
  { no: 8, name: "ORDER_STATUS_AUTH_FAILED" },
  { no: 9, name: "ORDER_STATUS_VOID_OK" },
  { no: 10, name: "ORDER_STATUS_SETTLE_OK" },
  { no: 11, name: "ORDER_STATUS_PARTIAL_SETTLED" },
]);

/**
 * Enumerates available payment gateways providers.
 *
 * @generated from enum gdx.gateway.web.payment.v2.PaymentGateway
 */
export enum PaymentGateway {
  /**
   * @generated from enum value: PAYMENT_GATEWAY_INVALID = 0;
   */
  INVALID = 0,

  /**
   * @generated from enum value: PAYMENT_GATEWAY_SOLID = 1;
   */
  SOLID = 1,
}
// Retrieve enum metadata with: proto3.getEnumType(PaymentGateway)
proto3.util.setEnumType(PaymentGateway, "gdx.gateway.web.payment.v2.PaymentGateway", [
  { no: 0, name: "PAYMENT_GATEWAY_INVALID" },
  { no: 1, name: "PAYMENT_GATEWAY_SOLID" },
]);

/**
 * Enumerates available payment method types.
 *
 * @generated from enum gdx.gateway.web.payment.v2.PaymentMethodType
 */
export enum PaymentMethodType {
  /**
   * @generated from enum value: PAYMENT_METHOD_TYPE_INVALID = 0;
   */
  INVALID = 0,

  /**
   * @generated from enum value: PAYMENT_METHOD_TYPE_CARD = 1;
   */
  CARD = 1,

  /**
   * @generated from enum value: PAYMENT_METHOD_TYPE_GOOGLE_PAY = 2;
   */
  GOOGLE_PAY = 2,

  /**
   * @generated from enum value: PAYMENT_METHOD_TYPE_APPLE_PAY = 3;
   */
  APPLE_PAY = 3,

  /**
   * @generated from enum value: PAYMENT_METHOD_TYPE_PAY_PAL = 5;
   */
  PAY_PAL = 5,
}
// Retrieve enum metadata with: proto3.getEnumType(PaymentMethodType)
proto3.util.setEnumType(PaymentMethodType, "gdx.gateway.web.payment.v2.PaymentMethodType", [
  { no: 0, name: "PAYMENT_METHOD_TYPE_INVALID" },
  { no: 1, name: "PAYMENT_METHOD_TYPE_CARD" },
  { no: 2, name: "PAYMENT_METHOD_TYPE_GOOGLE_PAY" },
  { no: 3, name: "PAYMENT_METHOD_TYPE_APPLE_PAY" },
  { no: 5, name: "PAYMENT_METHOD_TYPE_PAY_PAL" },
]);

/**
 * Describes payment method and it's settings.
 *
 * @generated from message gdx.gateway.web.payment.v2.PaymentMethod
 */
export class PaymentMethod extends Message<PaymentMethod> {
  /**
   * @generated from field: string name = 1;
   */
  name = "";

  /**
   * @generated from oneof gdx.gateway.web.payment.v2.PaymentMethod.method
   */
  method: {
    /**
     * @generated from field: gdx.gateway.web.payment.v2.PaymentMethodCard card = 2;
     */
    value: PaymentMethodCard;
    case: "card";
  } | {
    /**
     * @generated from field: gdx.gateway.web.payment.v2.PaymentMethodGooglePay google_pay = 3;
     */
    value: PaymentMethodGooglePay;
    case: "googlePay";
  } | {
    /**
     * @generated from field: gdx.gateway.web.payment.v2.PaymentMethodApplePay apple_pay = 4;
     */
    value: PaymentMethodApplePay;
    case: "applePay";
  } | {
    /**
     * @generated from field: gdx.gateway.web.payment.v2.PaymentMethodSolidPayPal solid_paypal = 7;
     */
    value: PaymentMethodSolidPayPal;
    case: "solidPaypal";
  } | { case: undefined; value?: undefined } = { case: undefined };

  constructor(data?: PartialMessage<PaymentMethod>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.gateway.web.payment.v2.PaymentMethod";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "card", kind: "message", T: PaymentMethodCard, oneof: "method" },
    { no: 3, name: "google_pay", kind: "message", T: PaymentMethodGooglePay, oneof: "method" },
    { no: 4, name: "apple_pay", kind: "message", T: PaymentMethodApplePay, oneof: "method" },
    { no: 7, name: "solid_paypal", kind: "message", T: PaymentMethodSolidPayPal, oneof: "method" },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): PaymentMethod {
    return new PaymentMethod().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): PaymentMethod {
    return new PaymentMethod().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): PaymentMethod {
    return new PaymentMethod().fromJsonString(jsonString, options);
  }

  static equals(a: PaymentMethod | PlainMessage<PaymentMethod> | undefined, b: PaymentMethod | PlainMessage<PaymentMethod> | undefined): boolean {
    return proto3.util.equals(PaymentMethod, a, b);
  }
}

/**
 * Describes single history item in account billing.
 * Possible `type` values: premium | premium_refund | add_credits | spend_credits.
 *
 * @generated from message gdx.gateway.web.payment.v2.BillingHistoryItem
 */
export class BillingHistoryItem extends Message<BillingHistoryItem> {
  /**
   * @generated from field: string type = 1;
   */
  type = "";

  /**
   * @generated from field: string title = 2;
   */
  title = "";

  /**
   * @generated from field: string description = 3;
   */
  description = "";

  /**
   * @generated from field: google.protobuf.Timestamp created_time = 4;
   */
  createdTime?: Timestamp;

  /**
   * @generated from field: string billing_position = 5;
   */
  billingPosition = "";

  constructor(data?: PartialMessage<BillingHistoryItem>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.gateway.web.payment.v2.BillingHistoryItem";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "type", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "title", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "description", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "created_time", kind: "message", T: Timestamp },
    { no: 5, name: "billing_position", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): BillingHistoryItem {
    return new BillingHistoryItem().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): BillingHistoryItem {
    return new BillingHistoryItem().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): BillingHistoryItem {
    return new BillingHistoryItem().fromJsonString(jsonString, options);
  }

  static equals(a: BillingHistoryItem | PlainMessage<BillingHistoryItem> | undefined, b: BillingHistoryItem | PlainMessage<BillingHistoryItem> | undefined): boolean {
    return proto3.util.equals(BillingHistoryItem, a, b);
  }
}

/**
 * Describes settings for card payment method.
 *
 * @generated from message gdx.gateway.web.payment.v2.PaymentMethodCard
 */
export class PaymentMethodCard extends Message<PaymentMethodCard> {
  constructor(data?: PartialMessage<PaymentMethodCard>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.gateway.web.payment.v2.PaymentMethodCard";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): PaymentMethodCard {
    return new PaymentMethodCard().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): PaymentMethodCard {
    return new PaymentMethodCard().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): PaymentMethodCard {
    return new PaymentMethodCard().fromJsonString(jsonString, options);
  }

  static equals(a: PaymentMethodCard | PlainMessage<PaymentMethodCard> | undefined, b: PaymentMethodCard | PlainMessage<PaymentMethodCard> | undefined): boolean {
    return proto3.util.equals(PaymentMethodCard, a, b);
  }
}

/**
 * Describes settings for google pay payment method.
 *
 * @generated from message gdx.gateway.web.payment.v2.PaymentMethodGooglePay
 */
export class PaymentMethodGooglePay extends Message<PaymentMethodGooglePay> {
  /**
   * @generated from field: string gateway = 1;
   */
  gateway = "";

  /**
   * @generated from field: string gateway_merchant_id = 2;
   */
  gatewayMerchantId = "";

  /**
   * @generated from field: string merchant_id = 3;
   */
  merchantId = "";

  /**
   * @generated from field: string merchant_name = 4;
   */
  merchantName = "";

  /**
   * @generated from field: repeated string allowed_card_networks = 5;
   */
  allowedCardNetworks: string[] = [];

  /**
   * @generated from field: repeated string allowed_card_auth_methods = 6;
   */
  allowedCardAuthMethods: string[] = [];

  constructor(data?: PartialMessage<PaymentMethodGooglePay>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.gateway.web.payment.v2.PaymentMethodGooglePay";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "gateway", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "gateway_merchant_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "merchant_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "merchant_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "allowed_card_networks", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 6, name: "allowed_card_auth_methods", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): PaymentMethodGooglePay {
    return new PaymentMethodGooglePay().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): PaymentMethodGooglePay {
    return new PaymentMethodGooglePay().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): PaymentMethodGooglePay {
    return new PaymentMethodGooglePay().fromJsonString(jsonString, options);
  }

  static equals(a: PaymentMethodGooglePay | PlainMessage<PaymentMethodGooglePay> | undefined, b: PaymentMethodGooglePay | PlainMessage<PaymentMethodGooglePay> | undefined): boolean {
    return proto3.util.equals(PaymentMethodGooglePay, a, b);
  }
}

/**
 * Describes settings for apple pay payment method.
 *
 * @generated from message gdx.gateway.web.payment.v2.PaymentMethodApplePay
 */
export class PaymentMethodApplePay extends Message<PaymentMethodApplePay> {
  /**
   * @generated from field: repeated string merchant_capabilities = 1;
   */
  merchantCapabilities: string[] = [];

  /**
   * @generated from field: repeated string supported_networks = 2;
   */
  supportedNetworks: string[] = [];

  /**
   * @generated from field: string merchant_id = 3;
   */
  merchantId = "";

  constructor(data?: PartialMessage<PaymentMethodApplePay>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.gateway.web.payment.v2.PaymentMethodApplePay";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "merchant_capabilities", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 2, name: "supported_networks", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 3, name: "merchant_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): PaymentMethodApplePay {
    return new PaymentMethodApplePay().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): PaymentMethodApplePay {
    return new PaymentMethodApplePay().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): PaymentMethodApplePay {
    return new PaymentMethodApplePay().fromJsonString(jsonString, options);
  }

  static equals(a: PaymentMethodApplePay | PlainMessage<PaymentMethodApplePay> | undefined, b: PaymentMethodApplePay | PlainMessage<PaymentMethodApplePay> | undefined): boolean {
    return proto3.util.equals(PaymentMethodApplePay, a, b);
  }
}

/**
 * Describes settings for payPal SOLID payment method.
 *
 * @generated from message gdx.gateway.web.payment.v2.PaymentMethodSolidPayPal
 */
export class PaymentMethodSolidPayPal extends Message<PaymentMethodSolidPayPal> {
  constructor(data?: PartialMessage<PaymentMethodSolidPayPal>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.gateway.web.payment.v2.PaymentMethodSolidPayPal";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): PaymentMethodSolidPayPal {
    return new PaymentMethodSolidPayPal().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): PaymentMethodSolidPayPal {
    return new PaymentMethodSolidPayPal().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): PaymentMethodSolidPayPal {
    return new PaymentMethodSolidPayPal().fromJsonString(jsonString, options);
  }

  static equals(a: PaymentMethodSolidPayPal | PlainMessage<PaymentMethodSolidPayPal> | undefined, b: PaymentMethodSolidPayPal | PlainMessage<PaymentMethodSolidPayPal> | undefined): boolean {
    return proto3.util.equals(PaymentMethodSolidPayPal, a, b);
  }
}

/**
 * Describes public payment card information.
 *
 * @generated from message gdx.gateway.web.payment.v2.PaymentCard
 */
export class PaymentCard extends Message<PaymentCard> {
  /**
   * @generated from field: string id = 1;
   */
  id = "";

  /**
   * @generated from field: string brand = 2;
   */
  brand = "";

  /**
   * @generated from field: string number = 3;
   */
  number = "";

  /**
   * source: card, google-pay, apple-pay
   *
   * @generated from field: string source = 4;
   */
  source = "";

  /**
   * @generated from field: gdx.gateway.web.payment.v2.PaymentGateway gateway = 5;
   */
  gateway = PaymentGateway.INVALID;

  constructor(data?: PartialMessage<PaymentCard>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.gateway.web.payment.v2.PaymentCard";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "brand", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "number", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "source", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "gateway", kind: "enum", T: proto3.getEnumType(PaymentGateway) },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): PaymentCard {
    return new PaymentCard().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): PaymentCard {
    return new PaymentCard().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): PaymentCard {
    return new PaymentCard().fromJsonString(jsonString, options);
  }

  static equals(a: PaymentCard | PlainMessage<PaymentCard> | undefined, b: PaymentCard | PlainMessage<PaymentCard> | undefined): boolean {
    return proto3.util.equals(PaymentCard, a, b);
  }
}

/**
 * Describes payment order status details.
 *
 * @generated from message gdx.gateway.web.payment.v2.PaymentOrderStatusDetails
 */
export class PaymentOrderStatusDetails extends Message<PaymentOrderStatusDetails> {
  /**
   * @generated from oneof gdx.gateway.web.payment.v2.PaymentOrderStatusDetails.status
   */
  status: {
    /**
     * @generated from field: gdx.gateway.web.payment.v2.PaymentOrderStatusProcessing processing = 1;
     */
    value: PaymentOrderStatusProcessing;
    case: "processing";
  } | {
    /**
     * @generated from field: gdx.gateway.web.payment.v2.PaymentOrderStatusSuccess success = 2;
     */
    value: PaymentOrderStatusSuccess;
    case: "success";
  } | {
    /**
     * @generated from field: gdx.gateway.web.payment.v2.PaymentOrderStatusFail fail = 3;
     */
    value: PaymentOrderStatusFail;
    case: "fail";
  } | {
    /**
     * @generated from field: gdx.gateway.web.payment.v2.PaymentOrderStatusVerification3ds verification3ds = 4;
     */
    value: PaymentOrderStatusVerification3ds;
    case: "verification3ds";
  } | {
    /**
     * @generated from field: gdx.gateway.web.payment.v2.PaymentOrderStatusRefund refund = 5;
     */
    value: PaymentOrderStatusRefund;
    case: "refund";
  } | { case: undefined; value?: undefined } = { case: undefined };

  constructor(data?: PartialMessage<PaymentOrderStatusDetails>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.gateway.web.payment.v2.PaymentOrderStatusDetails";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "processing", kind: "message", T: PaymentOrderStatusProcessing, oneof: "status" },
    { no: 2, name: "success", kind: "message", T: PaymentOrderStatusSuccess, oneof: "status" },
    { no: 3, name: "fail", kind: "message", T: PaymentOrderStatusFail, oneof: "status" },
    { no: 4, name: "verification3ds", kind: "message", T: PaymentOrderStatusVerification3ds, oneof: "status" },
    { no: 5, name: "refund", kind: "message", T: PaymentOrderStatusRefund, oneof: "status" },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): PaymentOrderStatusDetails {
    return new PaymentOrderStatusDetails().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): PaymentOrderStatusDetails {
    return new PaymentOrderStatusDetails().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): PaymentOrderStatusDetails {
    return new PaymentOrderStatusDetails().fromJsonString(jsonString, options);
  }

  static equals(a: PaymentOrderStatusDetails | PlainMessage<PaymentOrderStatusDetails> | undefined, b: PaymentOrderStatusDetails | PlainMessage<PaymentOrderStatusDetails> | undefined): boolean {
    return proto3.util.equals(PaymentOrderStatusDetails, a, b);
  }
}

/**
 * Describes payment order processing status.
 *
 * @generated from message gdx.gateway.web.payment.v2.PaymentOrderStatusProcessing
 */
export class PaymentOrderStatusProcessing extends Message<PaymentOrderStatusProcessing> {
  constructor(data?: PartialMessage<PaymentOrderStatusProcessing>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.gateway.web.payment.v2.PaymentOrderStatusProcessing";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): PaymentOrderStatusProcessing {
    return new PaymentOrderStatusProcessing().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): PaymentOrderStatusProcessing {
    return new PaymentOrderStatusProcessing().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): PaymentOrderStatusProcessing {
    return new PaymentOrderStatusProcessing().fromJsonString(jsonString, options);
  }

  static equals(a: PaymentOrderStatusProcessing | PlainMessage<PaymentOrderStatusProcessing> | undefined, b: PaymentOrderStatusProcessing | PlainMessage<PaymentOrderStatusProcessing> | undefined): boolean {
    return proto3.util.equals(PaymentOrderStatusProcessing, a, b);
  }
}

/**
 * Describes payment order success status.
 *
 * @generated from message gdx.gateway.web.payment.v2.PaymentOrderStatusSuccess
 */
export class PaymentOrderStatusSuccess extends Message<PaymentOrderStatusSuccess> {
  /**
   * @generated from field: uint64 price = 3;
   */
  price = protoInt64.zero;

  /**
   * @generated from field: string currency = 4;
   */
  currency = "";

  /**
   * @generated from field: string descriptor_text = 2;
   */
  descriptorText = "";

  constructor(data?: PartialMessage<PaymentOrderStatusSuccess>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.gateway.web.payment.v2.PaymentOrderStatusSuccess";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 3, name: "price", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
    { no: 4, name: "currency", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "descriptor_text", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): PaymentOrderStatusSuccess {
    return new PaymentOrderStatusSuccess().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): PaymentOrderStatusSuccess {
    return new PaymentOrderStatusSuccess().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): PaymentOrderStatusSuccess {
    return new PaymentOrderStatusSuccess().fromJsonString(jsonString, options);
  }

  static equals(a: PaymentOrderStatusSuccess | PlainMessage<PaymentOrderStatusSuccess> | undefined, b: PaymentOrderStatusSuccess | PlainMessage<PaymentOrderStatusSuccess> | undefined): boolean {
    return proto3.util.equals(PaymentOrderStatusSuccess, a, b);
  }
}

/**
 * Describes payment order fail status.
 *
 * @generated from message gdx.gateway.web.payment.v2.PaymentOrderStatusFail
 */
export class PaymentOrderStatusFail extends Message<PaymentOrderStatusFail> {
  /**
   * @generated from field: string code = 1;
   */
  code = "";

  /**
   * @generated from field: string message = 2;
   */
  message = "";

  /**
   * @generated from field: string recommendation = 3;
   */
  recommendation = "";

  /**
   * @generated from field: bool is_decline_retry = 4;
   */
  isDeclineRetry = false;

  /**
   * @generated from field: gdx.gateway.web.payment.v2.PaymentOrderStatusFail.Card card = 5;
   */
  card?: PaymentOrderStatusFail_Card;

  /**
   * @generated from field: int32 declined_retry_attempt = 6;
   */
  declinedRetryAttempt = 0;

  constructor(data?: PartialMessage<PaymentOrderStatusFail>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.gateway.web.payment.v2.PaymentOrderStatusFail";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "message", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "recommendation", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "is_decline_retry", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 5, name: "card", kind: "message", T: PaymentOrderStatusFail_Card },
    { no: 6, name: "declined_retry_attempt", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): PaymentOrderStatusFail {
    return new PaymentOrderStatusFail().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): PaymentOrderStatusFail {
    return new PaymentOrderStatusFail().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): PaymentOrderStatusFail {
    return new PaymentOrderStatusFail().fromJsonString(jsonString, options);
  }

  static equals(a: PaymentOrderStatusFail | PlainMessage<PaymentOrderStatusFail> | undefined, b: PaymentOrderStatusFail | PlainMessage<PaymentOrderStatusFail> | undefined): boolean {
    return proto3.util.equals(PaymentOrderStatusFail, a, b);
  }
}

/**
 * Describes declined card information.
 *
 * @generated from message gdx.gateway.web.payment.v2.PaymentOrderStatusFail.Card
 */
export class PaymentOrderStatusFail_Card extends Message<PaymentOrderStatusFail_Card> {
  /**
   * @generated from field: string brand = 1;
   */
  brand = "";

  /**
   * @generated from field: string number = 2;
   */
  number = "";

  /**
   * source: card, google-pay, apple-pay
   *
   * @generated from field: string source = 3;
   */
  source = "";

  /**
   * @generated from field: gdx.gateway.web.payment.v2.PaymentGateway gateway = 4;
   */
  gateway = PaymentGateway.INVALID;

  constructor(data?: PartialMessage<PaymentOrderStatusFail_Card>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.gateway.web.payment.v2.PaymentOrderStatusFail.Card";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "brand", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "number", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "source", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "gateway", kind: "enum", T: proto3.getEnumType(PaymentGateway) },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): PaymentOrderStatusFail_Card {
    return new PaymentOrderStatusFail_Card().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): PaymentOrderStatusFail_Card {
    return new PaymentOrderStatusFail_Card().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): PaymentOrderStatusFail_Card {
    return new PaymentOrderStatusFail_Card().fromJsonString(jsonString, options);
  }

  static equals(a: PaymentOrderStatusFail_Card | PlainMessage<PaymentOrderStatusFail_Card> | undefined, b: PaymentOrderStatusFail_Card | PlainMessage<PaymentOrderStatusFail_Card> | undefined): boolean {
    return proto3.util.equals(PaymentOrderStatusFail_Card, a, b);
  }
}

/**
 * Describes payment order 3ds verification status.
 *
 * @generated from message gdx.gateway.web.payment.v2.PaymentOrderStatusVerification3ds
 */
export class PaymentOrderStatusVerification3ds extends Message<PaymentOrderStatusVerification3ds> {
  /**
   * @generated from field: string verification_url = 1;
   */
  verificationUrl = "";

  /**
   * @generated from field: bool is_form_request = 2;
   */
  isFormRequest = false;

  constructor(data?: PartialMessage<PaymentOrderStatusVerification3ds>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.gateway.web.payment.v2.PaymentOrderStatusVerification3ds";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "verification_url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "is_form_request", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): PaymentOrderStatusVerification3ds {
    return new PaymentOrderStatusVerification3ds().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): PaymentOrderStatusVerification3ds {
    return new PaymentOrderStatusVerification3ds().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): PaymentOrderStatusVerification3ds {
    return new PaymentOrderStatusVerification3ds().fromJsonString(jsonString, options);
  }

  static equals(a: PaymentOrderStatusVerification3ds | PlainMessage<PaymentOrderStatusVerification3ds> | undefined, b: PaymentOrderStatusVerification3ds | PlainMessage<PaymentOrderStatusVerification3ds> | undefined): boolean {
    return proto3.util.equals(PaymentOrderStatusVerification3ds, a, b);
  }
}

/**
 * Describes payment order refund status.
 *
 * @generated from message gdx.gateway.web.payment.v2.PaymentOrderStatusRefund
 */
export class PaymentOrderStatusRefund extends Message<PaymentOrderStatusRefund> {
  /**
   * @generated from field: uint64 price = 2;
   */
  price = protoInt64.zero;

  /**
   * @generated from field: string currency = 3;
   */
  currency = "";

  constructor(data?: PartialMessage<PaymentOrderStatusRefund>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.gateway.web.payment.v2.PaymentOrderStatusRefund";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 2, name: "price", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
    { no: 3, name: "currency", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): PaymentOrderStatusRefund {
    return new PaymentOrderStatusRefund().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): PaymentOrderStatusRefund {
    return new PaymentOrderStatusRefund().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): PaymentOrderStatusRefund {
    return new PaymentOrderStatusRefund().fromJsonString(jsonString, options);
  }

  static equals(a: PaymentOrderStatusRefund | PlainMessage<PaymentOrderStatusRefund> | undefined, b: PaymentOrderStatusRefund | PlainMessage<PaymentOrderStatusRefund> | undefined): boolean {
    return proto3.util.equals(PaymentOrderStatusRefund, a, b);
  }
}

